module.exports = __webpack_public_path__ + "static/img/bubble-logo.bd88ae19.svg";